module.exports = __webpack_public_path__ + "img/20220910.1b03bb1d.png";